import { motion } from 'framer-motion';

/**
 * Modern Control Bar Component (Split Layout - Minimalist)
 * Shared navigation bar for lesson steps.
 */
function ControlBar({ onBack, onNext, canGoBack, backLabel = '이전', nextLabel = '다음', nextIcon = 'fa-arrow-right', extraButtons, isRunning }) {
  return (
    <div className="absolute inset-x-0 bottom-0 px-5 pb-3 pt-4 flex justify-between items-end pointer-events-none z-50">
      {/* Left Group: Back Button - Minimalist */}
      <div className="pointer-events-auto">
        <motion.button
          initial={{ x: -10, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          onClick={onBack}
          disabled={!canGoBack}
          className={`w-[46px] h-[46px] rounded-full flex items-center justify-center transition-all bg-slate-800/80 backdrop-blur-sm ${canGoBack
            ? 'hover:bg-slate-700 text-slate-400 hover:text-white'
            : 'text-slate-700 cursor-not-allowed opacity-0'
            }`}
          title={backLabel}
        >
          <i className="fas fa-arrow-left text-lg" />
        </motion.button>
      </div>

      {/* Right Group: Actions - Minimalist */}
      <div className="pointer-events-auto flex items-center gap-3">
        {extraButtons && (
          <div className="flex items-center">
            {extraButtons}
          </div>
        )}

        <motion.button
          initial={{ x: 10, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          onClick={onNext}
          disabled={isRunning}
          className={`w-[46px] h-[46px] rounded-full flex items-center justify-center transition-all active:scale-95 relative overflow-hidden group shadow-none ${isRunning
            ? 'bg-slate-700 text-slate-500 cursor-wait'
            : 'bg-white text-black hover:bg-slate-200'
            }`}
          title={nextLabel}
        >
          {isRunning ? (
            <i className="fas fa-spinner fa-spin text-lg"></i>
          ) : (
            <i className={`fas ${nextIcon === 'fa-arrow-right' ? 'fa-arrow-right' : nextIcon} text-xl`} />
          )}
        </motion.button>
      </div>
    </div>
  );
}

export default ControlBar;
